import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export function getAllManufacturers(token, query) {
  const qs = buildQuery(query);
  return axios.get(`${baseUrl}/getAllManufacturers${qs}`, {
    headers: {
      authorization: token,
    },
  });
};
export function AddNewManufacturers(token, data) {
  return axios.post(`${baseUrl}/insertManufacturer`, data, {
    headers: {
      authorization: token,
    },
  });
};
export function UpdateManufacturer(token, data, ID) {
  return axios.put(`${baseUrl}/updateManufacturer/${ID}`, data, {
    headers: {
      authorization: token,
    },
  });
};
export function getManufacturerByID(token, ID) {
  return axios.get(`${baseUrl}/getManufacturerById/${ID}`, {
    headers: {
      authorization: token,
    },
  });
};
export function UpdateStatusByID(token, data) {
  return axios.patch(`${baseUrl}/updateStockStatus`, data, {
    headers: {
      authorization: token,
    },
  });
};
export function UpdateIsActiveStatusByID(token, data) {
  return axios.patch(`${baseUrl}/updateIsActiveStatus`, data, {
    headers: {
      authorization: token,
    },
  });
};
export function deleteManufacturer(token, id) {
  return axios.delete(baseUrl + `/deleteManufacturer/${id}`, {
    headers: {
      Authorization: token,
    },
  });
};
